<script>
import MultiSelectHint from '@/components/ui/MultiSelectHint.vue'

export default {
  components: {
    'mia-multi-select-hint': MultiSelectHint
  },

  props: {
    value: {
      type: String,
      default: null
    }
  },

  data: () => ({
    orderStatus: [
      { id: 'empty', label: '(leer)' },
      { id: 'abgeschlossen', label: 'Abgeschlossen' },
      { id: 'bearbeitung', label: 'Bearbeitung' },
      { id: 'bestellt', label: 'Bestellt' },
      { id: 'eingeplant', label: 'Eingeplant' },
      { id: 'fakturiert', label: 'Fakturiert' },
      { id: 'geloescht', label: 'Gelöscht' },
      { id: 'hdl_ankunft', label: 'Hdl Ankunft' },
      { id: 'hdl_transport', label: 'Hdl Transport' },
      { id: 'im_trichter', label: 'Im Trichter' },
      { id: 'imp_akzeptiert', label: 'Imp Akzeptiert' },
      { id: 'imp_ankunft', label: 'Imp Ankunft' },
      { id: 'imp_transport', label: 'Imp Transport' },
      { id: 'in_produktion', label: 'In Produktion' },
      { id: 'int_transfer', label: 'Int Transfer' },
      { id: 'kd_ausgeliefert', label: 'Kd ausgeliefert' },
      { id: 'lieferung', label: 'Lieferung' },
      { id: 'produziert', label: 'Produziert' }
    ],
    selectedChanges: [],
    selectedStatus: []
  }),

  created() {
    this.parseInitialValue()
  },

  methods: {
    parseInitialValue() {
      if (!this.value) {
        return
      }

      try {
        const payload = JSON.parse(this.value)

        this.selectedChanges = payload.events || []
        this.selectedStatus = payload.status || []
      } catch (e) {
        // left blank intentionally
      }
    },

    onChange() {
      const payload = {
        events: this.selectedChanges,
        status: this.selectedStatus
      }

      this.$emit('change', JSON.stringify(payload))
    }
  }
}
</script>

<template>
  <div>
    <div class="grid grid-cols-2 gap-6">
      <div>
        <label class="text-sm block mb-1 mr-2 tracking-wider text-gray-800">Statusänderung</label>
        <select
          v-model="selectedChanges"
          class="w-full form-select"
          multiple
          @change="onChange"
        >
          <option value="enter">
            Bei Erhalt der/des Status
          </option>
          <option value="leave">
            Bei Verlassen der/des Status
          </option>
        </select>
        <mia-multi-select-hint />
      </div>
      <div>
        <label class="text-sm block mb-1 mr-2 tracking-wider text-gray-800">Status</label>
        <select
          v-model="selectedStatus"
          class="w-full form-select"
          multiple
          @change="onChange"
        >
          <option
            v-for="status in orderStatus"
            :key="status.id"
            :value="status.id"
          >
            {{ status.label }}
          </option>
        </select>
        <mia-multi-select-hint />
      </div>
    </div>
  </div>
</template>
